import Dto from "../../../../../../service/Dto";

class SubmitOutput extends Dto {

  name = '';
  queueName = '';
  config = '';
  scheduledDateTime = '';
  action = '';
  accountId = '';

  constructor(name = '', queueName = '', config = '', scheduledDateTime = '', action = '', accountId = '',
              _class = 'campaign\\module\\modules\\omsModule\\v001\\service\\dto\\SubmitOutput') {

    super(_class);
    this.name = name;
    this.queueName = queueName;
    this.config = config;
    this.scheduledDateTime = scheduledDateTime;
    this.action = action;
    this.accountId = accountId;
  }

  getAction() {
    return this.action;
  }

  setAction(value) {
    this.action = value;
  }

  getName() {
    return this.name;
  }

  setName(value) {
    this.name = value;
  }

  getQueueName() {
    return this.queueName;
  }

  setQueueName(value) {
    this.queueName = value;
  }

  getConfig() {
    return this.config;
  }

  setConfig(value) {
    this.config = value;
  }

  getScheduledDateTime() {
    return this.scheduledDateTime;
  }

  setScheduledDateTime(value) {
    this.scheduledDateTime = value;
  }

  getAccountId() {
    return this.accountId;
  }

  setAccountId(value) {
    this.accountId = value;
  }
}

export default SubmitOutput;
